import React from 'react';
import { Spin } from 'components';

import EmptyContainer from './EmptyContainer';

const Loading = () => (
    <EmptyContainer>
      <Spin size={'large'} />
    </EmptyContainer>
  );

export default Loading;
